import { useState } from "react";
import { Modal, Button } from "react-bootstrap";
import { format, addMinutes } from "date-fns";
import axios from "axios";
import getAPI from "../../service/getAPI";

const formatToIST = (utcDateString) => {
    const utcDate = new Date(utcDateString);
    const istDate = addMinutes(utcDate, 330); // Convert UTC to IST (+5:30)
    return format(istDate, "dd MMM yyyy, hh:mm a");
};

const QueryCountCell = ({ count, inquiry_id }) => {
    const { master } = getAPI();
    const [hovered, setHovered] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [logs, setLogs] = useState([]);
    const [loading, setLoading] = useState(false);

    const handleOpenModal = async () => {
        setShowModal(true);
        setLoading(true);
        try {
            const response = await axios.post(master.getInquirylog, {
                inquiry_id,
            });
            if (response.data.flag === 1) {
                setLogs(response.data.data);
            } else {
                setLogs([]);
            }
        } catch (error) {
            console.error("Failed to fetch logs", error);
            setLogs([]);
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => setShowModal(false);

    return (
        <>
            <td
                onMouseEnter={() => setHovered(true)}
                onMouseLeave={() => setHovered(false)}
                onClick={handleOpenModal}
                style={{
                    cursor: "pointer",
                    color: hovered ? "blue" : "inherit",
                }}
            >
                {count || 0}
            </td>

            <Modal show={showModal} onHide={handleCloseModal} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Query Logs</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {loading ? (
                        <div>Loading logs...</div>
                    ) : logs.length === 0 ? (
                        <div>No logs found.</div>
                    ) : (
                        logs.map((log) => (
                            <div
                                key={log.log_id}
                                style={{
                                    borderBottom: "1px solid #ddd",
                                    paddingBottom: "8px",
                                    marginBottom: "8px",
                                }}
                            >
                                <div>
                                    <strong>Mobile No:</strong> {log.order_mobile_no || "N/A"}
                                </div>
                                <div>
                                    <strong>Remark:</strong>{" "}
                                    {log.remark ? log.remark : <em>No Remark</em>}
                                </div>
                                <div>
                                    <strong>Time:</strong> {formatToIST(log.created_at)}
                                </div>
                            </div>
                        ))
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleCloseModal}>
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default QueryCountCell;